export default "/images/vendor/flag-icons/flags/4x3/hn.svg?2427006aada8b474df115cb6508daf42";